<div class="headerDialog">
    <h1 class="dialogTitle">
        <span class="mr-1">
            <mat-icon>{{icon}}</mat-icon>
        </span>
        {{ 'internal_message_title' | translate }}
    </h1>
    <button id="cancelled" mat-icon-button mat-dialog-close>
        <mat-icon>cancel</mat-icon>
    </button>
</div>
<div mat-dialog-content>

    <mat-form-field>
        <mat-label>{{ 'internal_message_mat_label' | translate }}</mat-label>
        <input matInput [formControl]="internalMessageValidator" cdkFocusInitial>
        <mat-error *ngIf="internalMessageValidator.errors">
            {{ 'form_error_required' | translate }}</mat-error>
    </mat-form-field>
</div>
<div mat-dialog-actions class="flexBtn mat-panel-footer display-flex">
    <button id="btnCancelMesInter" mat-button [color]="'material'|colors" [style.color]="'primary'|colors" (click)="onNoClick()">
        {{ 'internal_message_cancel_button' | translate }}
    </button>
    <button id="btnSendMesInter" mat-button [color]="'material'|colors" [style.color]="'primary'|colors" (click)="closeDialog()">
        {{ 'internal_message_send_button' | translate }}
    </button>
</div>
